export default "__VITE_ASSET__BKvmL1g9__"